var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "filter_svg2__a",
    x1: -8.85,
    x2: 219.52,
    y1: 137.02,
    y2: -13.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M76.18 94.51a12.33 12.33 0 0 1 3.25 8.35v90.95c0 5.47 6.61 8.25 10.51 4.4l25.37-29.07c3.4-4.07 5.27-6.09 5.27-10.12v-56.13c0-3.09 1.17-6.07 3.25-8.35l72.8-79C202.08 9.61 197.89 0 189.82 0H10.19C2.12 0-2.1 9.59 3.38 15.54z",
    style: {
      fill: "url(#filter_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgFilter;